import { anyOf, objectOf } from "@altostra/type-validations";
import { nullValidation, string } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementAppGroupIdContentBlocksIdPreviewThumbnailResult = objectOf({
  body: anyOf(string, nullValidation),
});
